import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/questionMark.svg';

export const IconQuestionMark = createIconComponent(Icon);
